export default __webpack_public_path__ + "static/media/wireframes-annototed.e65545d2.png";